(function() {
  'use strict';

  const config = window.PretiqueProductConfig || {};
  const sectionId = config.sectionId;
  const productId = config.productId;
  const productVariants = config.productVariants || [];
  const moneyFormat = (config.moneyFormat || '${{amount}}').replace(/\{\{/, '{').replace(/\}\}/, '}');

  let selectedOptions = config.selectedOptions || [];

  // ─── GALLERY ELEMENTS ─────────────────────────────────────────────────────
  const gallery = document.getElementById('sp-gallery-' + sectionId);
  const galleryMain = document.getElementById('sp-gallery-main-' + sectionId);

  let thumbnails, dots, slides, thumbnailsContainer;
  let isClickScrolling = false;
  let clickTimeout = null;

  if (gallery) {
    thumbnails = gallery.querySelectorAll('.sp-gallery__thumbnail');
    dots = gallery.querySelectorAll('.sp-gallery__dot');
    slides = gallery.querySelectorAll('.sp-gallery__slide');
    thumbnailsContainer = gallery.querySelector('.sp-gallery__thumbnails');
  }

  // ─── UTILS ────────────────────────────────────────────────────────────────
  
  function formatMoney(cents) {
    if (typeof window.formatMoney === 'function') return window.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }

  function selectMedia(mediaId) {
    if (!gallery || !mediaId) return;

    isClickScrolling = true;
    clearTimeout(clickTimeout);
    clickTimeout = setTimeout(() => { isClickScrolling = false; }, 800);

    const idStr = String(mediaId);

    if (thumbnails) {
      thumbnails.forEach(t => t.classList.toggle('is-selected', t.dataset.mediaId === idStr));
      // Move sliding underline indicator
      updateThumbIndicator();
    }
    if (dots) {
      dots.forEach(d => d.classList.toggle('is-selected', d.dataset.mediaId === idStr));
    }

    const isDesktopGrid = window.innerWidth >= 1000 && gallery.dataset.desktopLayout.startsWith('grid');

    if (isDesktopGrid) {
      // Desktop grid: smooth scroll to slide
      const targetSlide = document.getElementById('sp-media-' + mediaId);
      if (targetSlide) {
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Mobile/Carousel: Use scrollTo on the container to avoid scrolling the whole window
      const container = document.getElementById('sp-gallery-slides-' + sectionId);
      const targetSlide = document.getElementById('sp-media-' + mediaId);
      if (container && targetSlide) {
        container.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  // Sliding underline indicator for active thumbnail — desktop uses .sp-gallery__thumb-indicator div
  // Mobile uses ::after on thumbnail, width set via CSS custom property
  function updateThumbIndicator() {
    if (!thumbnails) return;
    const active = Array.from(thumbnails).find(t => t.classList.contains('is-selected'));
    if (!active) return;

    const img = active.querySelector('img');
    const thumbLeft = active.offsetLeft;
    const thumbWidth = active.offsetWidth;
    const imgWidth = img ? img.offsetWidth : thumbWidth;

    // Desktop: update the indicator div
    const indicator = document.querySelector('.sp-gallery__thumb-indicator');
    if (indicator) {
      indicator.style.left = thumbLeft + 'px';
      indicator.style.width = imgWidth + 'px';
    }

    // Mobile: set CSS var on active thumbnail for ::after width
    thumbnails.forEach(t => {
      const tImg = t.querySelector('img');
      const w = tImg ? tImg.offsetWidth : t.offsetWidth;
      t.style.setProperty('--thumb-indicator-w', w + 'px');
    });
  }

  // ─── GALLERY INITIALIZATION ──────────────────────────────────────────────
  if (gallery) {
    if (thumbnails) {
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMedia(thumb.dataset.mediaId);
          updateThumbIndicator();
        });
      });
      // Init indicator on load
      requestAnimationFrame(() => updateThumbIndicator());
    }

    if (dots) {
      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMedia(dot.dataset.mediaId);
        });
      });
    }

    // On mobile, slides scroll inside the container — use it as root for accurate detection
    const slidesContainer = document.getElementById('sp-gallery-slides-' + sectionId);
    const isMobileSlider = () => window.innerWidth < 1000 &&
      (gallery.dataset.mobileControls === 'thumbnails' ||
       gallery.dataset.mobileControls === 'free_scroll' ||
       gallery.dataset.mobileControls === 'dots');

    const galleryObserver = new IntersectionObserver((entries) => {
      if (isClickScrolling) return;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const mediaId = entry.target.dataset.mediaId;

          if (thumbnails) {
            thumbnails.forEach(t => {
              const isActive = t.dataset.mediaId === mediaId;
              t.classList.toggle('is-selected', isActive);

              if (isActive && thumbnailsContainer && window.innerWidth >= 1000 && gallery.dataset.desktopLayout === 'grid') {
                const tTop = t.offsetTop;
                const cTop = thumbnailsContainer.scrollTop;
                const cHeight = thumbnailsContainer.clientHeight;

                if (tTop < cTop || (tTop + t.clientHeight) > (cTop + cHeight)) {
                  thumbnailsContainer.scrollTo({ top: tTop - 20, behavior: 'smooth' });
                }
              }

              // Mobile thumbnail strip: scroll active thumb into view
              if (isActive && thumbnailsContainer && window.innerWidth < 1000) {
                const tLeft = t.offsetLeft;
                const cLeft = thumbnailsContainer.scrollLeft;
                const cWidth = thumbnailsContainer.clientWidth;
                if (tLeft < cLeft || (tLeft + t.clientWidth) > (cLeft + cWidth)) {
                  thumbnailsContainer.scrollTo({ left: tLeft - 10, behavior: 'smooth' });
                }
              }
            });
          }

          if (dots) {
            dots.forEach(d => d.classList.toggle('is-selected', d.dataset.mediaId === String(mediaId)));
          }
        }
      });
    }, {
      root: isMobileSlider() && slidesContainer ? slidesContainer : null,
      rootMargin: isMobileSlider() ? '0px' : '-30% 0px -40% 0px',
      threshold: 0.5
    });

    if (slides) {
      slides.forEach(slide => galleryObserver.observe(slide));
    }
  }

  // ─── LIGHTBOX ────────────────────────────────────────────────────────────
  const lightbox      = document.getElementById('sp-lightbox-' + sectionId);
  const slider        = document.getElementById('sp-lightbox-slider-' + sectionId);
  const btnPrev       = document.getElementById('sp-lightbox-prev-' + sectionId);
  const btnNext       = document.getElementById('sp-lightbox-next-' + sectionId);
  const btnClose      = document.getElementById('sp-lightbox-close-' + sectionId);
  const overlayClose  = document.getElementById('sp-lightbox-close-overlay-' + sectionId);
  const btnZoom       = document.getElementById('sp-gallery-zoom-' + sectionId);

  function openLightbox(index) {
    if (!lightbox || !slider) return;
    lightbox.classList.add('is-open');
    lightbox.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    // Jump to correct slide instantly on open
    const slideWidth = slider.clientWidth;
    if (slideWidth > 0) slider.scrollTo({ left: slideWidth * index, behavior: 'instant' });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (galleryMain && lightbox) {
    slides.forEach(slide => {
      // Unified single-click zoom for both Desktop and Mobile
      slide.addEventListener('click', (e) => {
        // Disable on mobile
        if (window.innerWidth < 1000) return;
        
        if (e.target.tagName.toLowerCase() === 'img') {
          openLightbox(parseInt(slide.dataset.index));
        }
      });
    });
  }

  // ─── GALLERY NAV BUTTONS (Desktop Only) ──────────────────────────────────
  const galleryPrev = document.getElementById('sp-gallery-prev-' + sectionId);
  const galleryNext = document.getElementById('sp-gallery-next-' + sectionId);

  if (galleryPrev && galleryNext && thumbnails && thumbnails.length > 1) {
    const handleNav = (dir) => {
      if (window.innerWidth < 1000) return; // Only desktop
      const activeThumb = Array.from(thumbnails).findIndex(t => t.classList.contains('is-selected'));
      if (activeThumb === -1) return;

      let nextIdx;
      if (dir === 'next') {
        nextIdx = (activeThumb + 1) % thumbnails.length;
      } else {
        nextIdx = (activeThumb - 1 + thumbnails.length) % thumbnails.length;
      }

      const nextMediaId = thumbnails[nextIdx].dataset.mediaId;
      selectMedia(nextMediaId);
    };

    galleryPrev.addEventListener('click', (e) => {
      e.stopPropagation();
      handleNav('prev');
    });
    galleryNext.addEventListener('click', (e) => {
      e.stopPropagation();
      handleNav('next');
    });
  }

  if (lightbox) {
    if (btnClose) btnClose.addEventListener('click', closeLightbox);
    if (btnZoom) {
      btnZoom.addEventListener('click', () => {
        const currentSlide = Array.from(slides).findIndex(s => !s.classList.contains('sp-visually-hidden') && !s.classList.contains('sp-filter-hidden'));
        openLightbox(currentSlide >= 0 ? currentSlide : 0);
      });
    }
    if (overlayClose) overlayClose.addEventListener('click', closeLightbox);

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', () => {
        slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
      });
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  // Init thumb indicator on load and resize
  if (typeof updateThumbIndicator === 'function') {
    window.addEventListener('load', updateThumbIndicator);
    window.addEventListener('resize', updateThumbIndicator);
  }

  // ─── VARIANT SELECTION ───────────────────────────────────────────────────
  function getMatchingVariant(options) {
    return productVariants.find(v =>
      v.options.every((opt, i) => opt === options[i])
    ) || null;
  }

  function updateVariant(variant) {
    const mainAtcBtn = document.getElementById('sp-atc-' + sectionId);
    const stickyAtcBtn = document.querySelector(`[data-sticky-atc="${sectionId}"]`);
    const atcBtns = [mainAtcBtn, stickyAtcBtn].filter(b => !!b);

    if (!variant) {
      atcBtns.forEach(btn => {
        btn.disabled = true;
        btn.classList.add('sp-btn--disabled');
        const text = btn.querySelector('.sp-btn__text');
        if (text) text.textContent = 'Unavailable';
      });
      return;
    }

    // 1. Update Hidden IDs
    const variantInput = document.getElementById('sp-variant-id-' + sectionId);
    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2. Update Prices (Main and Sticky)
    const priceEl = document.getElementById('sp-price-' + sectionId);
    const stickyPriceEl = document.querySelector(`[data-sticky-price="${sectionId}"]`);

    if (priceEl) {
      const formattedPrice = formatMoney(variant.price);
      const formattedCompare = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
      
      let html = '';
      if (formattedCompare && variant.compare_at_price > variant.price) {
        html = `<s class="sp-price sp-price--compare">${formattedCompare}</s>
                <span class="sp-price sp-price--sale">${formattedPrice}</span>`;
      } else {
        html = `<span class="sp-price">${formattedPrice}</span>`;
      }
      const priceList = priceEl.querySelector('.sp-price-list');
      if (priceList) priceList.innerHTML = html;
    }

    if (stickyPriceEl) {
      stickyPriceEl.textContent = formatMoney(variant.price);
    }

    // 2.5. Update Sticky Variant Title
    const stickyVariantEl = document.querySelector(`[data-sticky-variant="${sectionId}"]`);
    if (stickyVariantEl) {
      stickyVariantEl.textContent = variant.title.includes('Default') ? '' : variant.title;
    }

    // 3. Update Gallery
    const imageId = variant.featured_media ? variant.featured_media.id :
                   (variant.featured_image ? variant.featured_image.id : variant.image_id);

    if (imageId) {
      selectMedia(imageId);
    }

    // 4. Update Sticky Bar Image
    const stickyImg = document.querySelector(`[data-sticky-img="${sectionId}"]`);
    if (stickyImg && (variant.featured_image || variant.featured_media)) {
      const imgObj = variant.featured_image || variant.featured_media;
      const src = imgObj.src || imgObj.preview_image.src;
      if (src) {
        // Simple Shopify thumbnail replacement
        const thumbUrl = src.replace(/\.(jpg|png|webp|jpeg)/, '_120x.$1');
        stickyImg.src = thumbUrl;
      }
    }

    // 5. Update Buttons State
    atcBtns.forEach(btn => {
      const textSpan = btn.querySelector('.sp-btn__text');
      if (!variant.available) {
        btn.disabled = true;
        btn.classList.add('sp-btn--disabled');
        if (textSpan) textSpan.textContent = 'Sold Out';
      } else {
        btn.disabled = false;
        btn.classList.remove('sp-btn--disabled');
        if (textSpan) textSpan.textContent = btn.getAttribute('data-atc-text') || 'Add to Cart';
      }
    });

    // 6. Update SKU
    const skuEl = document.querySelector(`#sp-info-${sectionId} .sp-sku span[data-sku-text]`);
    if (skuEl) skuEl.textContent = variant.sku || "";

    // 6.5 Update Inventory
    const inventoryEl = document.getElementById('sp-inventory-' + sectionId);
    if (inventoryEl && variant) {
      const qty = config.variantInventories ? config.variantInventories[variant.id] : 0;
      const lowThreshold = parseInt(inventoryEl.dataset.lowThreshold) || 10;
      const showQty = inventoryEl.dataset.showQty === 'true';
      const showBar = inventoryEl.dataset.showBar === 'true';
      const barMax = parseInt(inventoryEl.dataset.barMax) || 50;

      let invHtml = '';
      if (!variant.available) {
        invHtml = `<div class="sp-inventory__status">
                  <span class="sp-inventory__dot sp-inventory__dot--out-of-stock"></span>
                  <span>Out of stock</span>
                </div>`;
      } else if (qty > lowThreshold || qty <= 0) {
         invHtml = `<div class="sp-inventory__status">
                  <span class="sp-inventory__dot sp-inventory__dot--in-stock"></span>
                  <span>In stock</span>
                  ${showQty && qty > 0 ? `<span class="sp-inventory__count">(${qty} items)</span>` : ''}
                </div>`;
      } else {
         invHtml = `<div class="sp-inventory__status">
                  <span class="sp-inventory__dot sp-inventory__dot--low-stock"></span>
                  <span>Only ${qty} left</span>
                </div>`;
      }
      if (showBar && qty > 0 && variant.available) {
        let barWidth = (qty * 100) / barMax;
        if (barWidth > 100) barWidth = 100;
        invHtml += `<div class="sp-inventory__bar-wrap">
                  <div class="sp-inventory__bar" style="--inventory-width: ${barWidth}%;"></div>
                 </div>`;
      }
      inventoryEl.innerHTML = invHtml;
    }

    // 7. Update URL
    if (window.history && window.history.replaceState) {
      const newUrl = window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({}, '', newUrl);
    }

    // 8. Active Image Filtering
    filterGallery(variant);
  }

  function filterGallery(variant) {
    if (!gallery || gallery.dataset.filteringEnabled !== 'true') return;

    // Find if any selected option matches an image alt
    let activeFilter = null;
    for (const optValue of selectedOptions) {
      const hasMatch = Array.from(thumbnails).some(t => t.dataset.mediaAlt === optValue);
      if (hasMatch) {
        activeFilter = optValue;
        break;
      }
    }

    if (activeFilter) {
      let firstMatchId = null;

      // Filter Thumbnails
      thumbnails.forEach(t => {
        const isMatch = t.dataset.mediaAlt === activeFilter;
        t.classList.toggle('sp-filter-hidden', !isMatch);
        if (isMatch && !firstMatchId) firstMatchId = t.dataset.mediaId;
      });

      // Filter Slides
      if (slides) {
        slides.forEach(s => {
          const isMatch = s.dataset.mediaAlt === activeFilter;
          s.classList.toggle('sp-filter-hidden', !isMatch);
        });
      }

      // Filter Dots
      if (dots) {
        dots.forEach(d => {
          const matchingThumb = Array.from(thumbnails).find(t => t.dataset.mediaId === d.dataset.mediaId);
          if (matchingThumb) {
            d.classList.toggle('sp-filter-hidden', matchingThumb.classList.contains('sp-filter-hidden'));
          }
        });
      }

      // Select first matching media if current is hidden
      const currentSelected = gallery.querySelector('.sp-gallery__thumbnail.is-selected');
      if (currentSelected && currentSelected.classList.contains('sp-filter-hidden') && firstMatchId) {
        selectMedia(firstMatchId);
      } else if (!currentSelected && firstMatchId) {
        selectMedia(firstMatchId);
      }
    } else {
      // No match found or show all
      if (thumbnails) thumbnails.forEach(t => t.classList.remove('sp-filter-hidden'));
      if (slides) slides.forEach(s => s.classList.remove('sp-filter-hidden'));
      if (dots) dots.forEach(d => d.classList.remove('sp-filter-hidden'));
    }
  }

  // ─── EVENTS ──────────────────────────────────────────────────────────────
  document.querySelectorAll('#sp-section-' + sectionId + ' [data-option-selector]').forEach(select => {
    select.addEventListener('change', e => {
      const idx = parseInt(select.dataset.optionIndex);
      selectedOptions[idx] = select.value;
      const variant = getMatchingVariant(selectedOptions);
      updateVariant(variant);
    });
  });

  document.querySelectorAll('#sp-section-' + sectionId + ' .sp-selector-block, #sp-section-' + sectionId + ' .sp-selector-swatch, #sp-section-' + sectionId + ' .sp-selector-variant-img').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex);
      const value = btn.dataset.optionValue;
      selectedOptions[idx] = value;

      const siblingGroup = btn.closest('.sp-selector-blocks, .sp-selector-swatches, .sp-selector-variant-images');
      if (siblingGroup) {
        siblingGroup.querySelectorAll('.sp-selector-block, .sp-selector-swatch, .sp-selector-variant-img').forEach(b => b.classList.remove('is-selected'));
      }
      btn.classList.add('is-selected');

      const labelSpan = document.getElementById('sp-option-selected-' + sectionId + '-' + (idx + 1));
      if (labelSpan) {
        labelSpan.textContent = value;
        labelSpan.style.display = 'inline';
      }

      const variant = getMatchingVariant(selectedOptions);
      updateVariant(variant);
    });
  });

  // ─── QUANTITY ────────────────────────────────────────────────────────────
  const qtyInput = document.getElementById('sp-qty-' + sectionId);
  const qtyMinus = document.getElementById('sp-qty-minus-' + sectionId);
  const qtyPlus  = document.getElementById('sp-qty-plus-' + sectionId);

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });
  }

  // ─── ACCORDIONS ──────────────────────────────────────────────────────────
  document.querySelectorAll('#sp-section-' + sectionId + ' [data-sp-accordion], .sp-content-below[data-sp-accordion]').forEach(acc => {
    const trigger = acc.querySelector('.sp-accordion__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const isOpen = acc.classList.contains('is-open');
      acc.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ─── MODALS ──────────────────────────────────────────────────────────────
  document.querySelectorAll('[data-modal-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = document.getElementById(btn.dataset.modalOpen);
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });
  document.querySelectorAll('[data-modal-close]').forEach(el => {
    el.addEventListener('click', () => {
      const modal = document.getElementById(el.dataset.modalClose);
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // ─── STICKY BAR ──────────────────────────────────────────────────────────
  const stickyBar = document.getElementById('sp-sticky-bar-' + sectionId);
  const productSection = document.getElementById('sp-section-' + sectionId);
  const atcBtnEl = document.getElementById('sp-atc-' + sectionId);

  if (stickyBar && (productSection || atcBtnEl)) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const show = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', String(!show));
        });
      },
      { threshold: 0, rootMargin: '0px 0px -100px 0px' }
    );
    if (atcBtnEl) observer.observe(atcBtnEl);
    else observer.observe(productSection);
  }

  // ─── STICKY ATC BEHAVIOR ─────────────────────────────────────────────────
  const stickyAtcBtnElem = document.querySelector('[data-sticky-atc="' + sectionId + '"]');
  if (stickyAtcBtnElem && stickyAtcBtnElem.dataset.stickyBehavior === 'scroll') {
    stickyAtcBtnElem.addEventListener('click', (e) => {
      e.preventDefault();
      const variantPicker = document.querySelector('#sp-section-' + sectionId + ' .sp-variant-option');
      if (variantPicker) {
        variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const msg = document.getElementById('sp-variant-select-message-' + sectionId);
        if (msg) {
          msg.style.display = 'block';
          setTimeout(() => { msg.style.display = 'none'; }, 3000);
        }
      }
    });
  }

  // ─── AJAX ADD TO CART ────────────────────────────────────────────────────
  const productForm = document.getElementById('product-form-main-' + productId + '-' + sectionId);
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const vidInput = productForm.querySelector('[name="id"]');
      const qInput = productForm.querySelector('[name="quantity"]');
      const variantId = vidInput ? vidInput.value : null;
      const quantity = qInput ? qInput.value : 1;

      if (!variantId) return;

      const atcBtn = document.getElementById('sp-atc-' + sectionId);
      const stickyAtcBtn = document.querySelector('[data-sticky-atc="' + sectionId + '"]');
      const allAtcBtns = [atcBtn, stickyAtcBtn].filter(b => b !== null);

      allAtcBtns.forEach(btn => {
        btn.classList.add('is-loading');
        btn.disabled = true;
      });

      // Personalisation: when the form carries filled properties[...] (text or file uploads), send them too.
      // The cart drawer posts this FormData as multipart to /cart/add.js (see snippets/pq-cart-drawer.liquid addItem).
      let formData = null;
      try {
        const all = new FormData(productForm);
        const clean = new FormData();
        let hasProps = false;
        all.forEach((v, k) => {
          const filled = typeof v === 'string' ? v.trim() !== '' : !!(v && v.size);
          if (/^properties\[/.test(k)) { if (filled) { hasProps = true; clean.append(k, v); } }
          else if (k === 'selling_plan' && filled) { clean.append(k, v); }
        });
        if (hasProps) {
          clean.append('id', variantId);
          clean.append('quantity', String(parseInt(quantity) || 1));
          formData = clean;
        }
      } catch (err) { formData = null; }

      document.dispatchEvent(new CustomEvent('cart:add', {
        detail: {
          id: variantId,
          qty: parseInt(quantity),
          formData: formData
        }
      }));

      // Re-enable buttons. Photo uploads can take a few seconds, so with formData wait for the drawer's done event.
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        document.removeEventListener('pq:cart-add-done', release);
        allAtcBtns.forEach(btn => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      };
      if (formData) {
        document.addEventListener('pq:cart-add-done', release);
        setTimeout(release, 20000);
      } else {
        setTimeout(release, 1000);
      }
    });
  }

  // ─── RECENTLY VIEWED ─────────────────────────────────────────────────────
  try {
    const rvProductId = config.productId;
    if (rvProductId) {
      let rv = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
      rv = rv.filter(item => item !== rvProductId);
      rv.unshift(rvProductId);
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(rv));
    }
  } catch (e) {
    console.warn('Recently viewed error:', e);
  }


})();
